import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    } else if (consent === 'accepted') {
      // Load tracking scripts if previously accepted
      loadTrackingScripts();
    }
  }, []);

  const loadTrackingScripts = () => {
    // Load Google Analytics
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-Z0F9KVGBLL';
    document.head.appendChild(gaScript);

    const gaConfig = document.createElement('script');
    gaConfig.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-Z0F9KVGBLL');
    `;
    document.head.appendChild(gaConfig);
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    loadTrackingScripts();
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      <style>{`
        .cookie-banner-overlay {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 9999;
          background: rgba(34, 21, 8, 0.96);
          backdrop-filter: blur(8px);
          border-top: 0.5px solid rgba(196, 168, 130, 0.3);
          animation: slideUp 0.4s ease-out;
          box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);
        }

        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .cookie-banner-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 24px 48px;
        }

        .cookie-banner-text {
          color: #F5F0E8;
          font-size: 14px;
          line-height: 1.7;
          margin-bottom: 20px;
          font-weight: 300;
        }

        .cookie-banner-text a {
          color: #C4A882;
          text-decoration: underline;
          transition: color 0.2s;
        }

        .cookie-banner-text a:hover {
          color: #D4BCA0;
        }

        .cookie-banner-buttons {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          align-items: center;
        }

        .cookie-btn {
          padding: 10px 28px;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          font-weight: 500;
          font-family: 'DM Sans', sans-serif;
        }

        .cookie-btn-accept {
          background: #C4A882;
          color: #2C1F14;
        }

        .cookie-btn-accept:hover {
          background: #D4BCA0;
          transform: translateY(-2px);
        }

        .cookie-btn-decline {
          background: transparent;
          color: #9B7F5F;
          border: 0.5px solid #4A3728;
        }

        .cookie-btn-decline:hover {
          border-color: #C4A882;
          color: #C4A882;
        }

        @media (max-width: 768px) {
          .cookie-banner-content {
            padding: 20px;
          }
          
          .cookie-banner-buttons {
            flex-direction: column;
            align-items: stretch;
          }
          
          .cookie-btn {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>

      <div className="cookie-banner-overlay">
        <div className="cookie-banner-content">
          <p className="cookie-banner-text">
            This website uses cookies, including Google Analytics, to improve your experience. 
            By clicking "Accept", you consent to the use of cookies. See our{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> for details.
          </p>

          <div className="cookie-banner-buttons">
            <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
              Accept
            </button>
            <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
              Decline
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;